module.exports = __webpack_public_path__ + "img/graphic-3.e88b80c0.png";